<div class="p-grid mu-text-align-left">
    <form class="p-col">
        <p-fileUpload 
            #fileUploadControl 
            id="mu-file-create"
            chooseLabel="{{ 'context.massive.fileUploadForm.loadFileButton' | translate}}" 
            name="myfile[]"
            [accept]="fileFormatsAllowedToUpload" 
            [auto]="true" 
            [customUpload]="true"
            (onRemove)="handleFilePending()" 
            (onSelect)="handleFilePending()"
            (uploadHandler)="eventLoadExcelFile(fileUploadControl, $event)"> 
            <ng-template let-file pTemplate="file">
                <div>
                    <i class="mu-icon-sticky-note" aria-hidden="true"></i>
                    {{file.name}}
                </div>
            </ng-template>
        </p-fileUpload>
        <div class="p-grid">    
            <app-mu-button 
                id="fileUpload-button-spacing"
                label="{{ 'context.massive.fileUploadForm.cancelButton' | translate}}"
                [disabled]="this.flagList.get(this.uploadFileFlag)" 
                class="mu-button-outline p-col-12 p-md-6 p-my-0"
                (click)="cancelLoad(fileUploadControl)">
            </app-mu-button>
            <app-mu-button 
                label="{{ 'context.massive.fileUploadForm.confirmButton' | translate}}"
                class="p-col-12 p-md-6 p-my-0"
                [flagList]="flagList"
                [flag]="uploadFileFlag"
                [disabled]="!this.fileUploaded"
                >
            </app-mu-button>
        </div>
    </form>
</div>